export const initialWishlistState = {
  wishlist: [],
};
